<template>
  <div id="about">
    <v-sheet id="main" class="overflow-y-auto">
      <v-layout class="pt-lg-10 pt-sm-10" column align-center justify-center>
        <v-row style="width: 83% !important;">
          <v-col class="text-left" cols="12">
            <h1 class="primary300--text mb-2 text-left">
              Hosting Institution
            </h1>
          </v-col>
        </v-row>
        <v-row id="hosting-row" class="mb-10 mx-10">
          <v-col
            xl="5"
            sm="5"
            lg="5"
            md="5"
            cols="12"
            v-for="institution in institutions"
            :key="'institution-' + institution.id"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                class="institution-card"
                :class="{ 'on-hover': hover }"
                :to="'/public-marketplace/marketplace/providers?institutions=' + institution.id"
              >
                <v-row class="pa-2">
                  <v-col cols="12" md="31" xl="3" sm="12" lg="3" class="text-center">
                    <v-avatar size="100px" class="rounded-xl">
                      <v-img contain :src="institution.logoUrl">
                        <template v-slot:placeholder>
                          <v-img lazy-src="@/assets/img/blur.jpg"></v-img>
                        </template>
                      </v-img>
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" md="8" xl="8" sm="12" lg="8" class="text-left">
                    <div class="d-flex flex-row">
                      <div>
                        <h4 class="neutral800--text text-bold">
                          {{ institution.name }}
                        </h4>
                        <div>
                          <span class="font-weight-bold neutral700--text">Address:</span>
                          {{ institution.address }}
                        </div>
                        <div @click.stop="">
                          <span class="font-weight-bold neutral700--text">Website: </span>
                          <a
                            target="_blank"
                            style="z-index: 9 !important;"
                            :href="institution.url"
                            class="on-hover-underline"
                            >{{ institution.url }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-layout>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      institutions: [],
    };
  },
  mounted() {
    //this.$vuetify.goTo(1, {});
    this.axios.get('/api/v1/institutions-full').then(res => {
      this.institutions = res.data.content;
    });
  },
};
</script>
